import React, { useState, useEffect } from 'react';
import MainLayout from '../Layouts/MainLayout';
import SideBar from '../Layouts/SideBar';
import CustomList from '../Layouts/CustomList';
import Instance from '../Services/Instance';
import config from '../Services/config';

function Faqs() {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const result = await Instance.get(`${config.api_url}/faq/items`);
                setFaqs(result.data.data.items || []);
                setLoading(false);
            } catch (error) {
                console.error("Erreur lors du chargement des FAQs:", error);
                setLoading(false);
            }
        };

        fetchFaqs();
    }, []);

    const safeFaqs = Array.isArray(faqs) ? faqs : [];
    
    const barParams = { 
        nav1: 'Question', 
        nav2: 'Catégorie',
        nav3: 'Publié', 
        nav4: 'Vues', 
        nav5: '' 
    };
    
    const titleItem = { 
        name: "FAQs", 
        title1: "Nouvelle FAQ", 
        title2: "FAQs", 
        title3: "FAQs", 
        title4: "FAQs"
    };
    
    const linkItem = {  
        link1: "/dashboard/faqs/add-faq", 
        link2: "#", 
        link3: "#", 
        link4: "#"
    };
    
    const linkList = { 
        show: `/dashboard/faq/show-faq`, 
        edit: "/dashboard/faq/edit-faq"
    };

    if (loading) {
        return (
            <div className='Product-layout'>
                <SideBar />
                <div style={{ padding: '20px' }}>Chargement...</div>
            </div>
        );
    }

    return (
        <div className='Product-layout'>
            <SideBar />
            <MainLayout 
                titleItem={titleItem}
                linkItem={linkItem}
                numberItem={safeFaqs.length}
            />
            <CustomList
                barParams={barParams}
                listItems={[...safeFaqs].reverse()}
                linkList={linkList}
                key1="title"
                key2="category"
                key3="isPublished"
                key4="views"
                key5=""
                idKey="_id"
                urlDelete="faq/items"
            />
        </div>
    );
}

export default Faqs;